<script setup lang="ts">
const show = ref(false)

const handleScroll = () => {
  show.value = window.scrollY > 400
}

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="translate-y-10 opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-10 opacity-0"
  >
    <div
      v-if="show"
      class="fixed bottom-8 right-8 z-50 animate-in fade-in slide-in-from-bottom-4 duration-500"
    >
      <UButton
        icon="i-heroicons-arrow-up"
        color="primary"
        size="xl"
        class="rounded-full shadow-2xl shadow-primary-500/40 hover:scale-110 active:scale-95 transition-all w-14 h-14 flex items-center justify-center p-0"
        @click="scrollToTop"
      />
    </div>
  </Transition>
</template>
